import {InspectedListPage} from 'modules/InspectedList';

export default InspectedListPage;
